import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  Input,
  Row,
  Spinner,
  FormGroup,
  Label,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import moment from 'moment';
import {
  AxiosAPI,
  AxiosPublicAPI,
  getGroupID,
} from '../../../../../../helpers/AxiosAPI';
import parse from 'html-react-parser';
import Axios from 'axios';
import {
  postAPI_GPT_Query,
  gAPI_Internal_Property_By_Id,
} from '../../../../../../constants/APIs';

const PreviewReply = ({
  saveIntegration,
  propertyList,
  channelDetails,
  propertyId,
  propertyDetails,
  lang,
}) => {
  console.error(propertyDetails, 'propertyDetails');
  const [property, setProperty] = useState();
  const [dynamicFlowList, setDyanmicFlowList] = useState(
    channelDetails?.autonomousReplies?.dynamicConversationFlow || []
  );
  const [isLoading, setIsLoading] = useState(false);
  const [emailText, setEmailText] = useState('');
  const [questionSet, setQuestionSet] = useState();
  const [reply, setReply] = useState('');
  const [pid, setPid] = useState(propertyId);
  //  templates state
  const [templates, setTemplates] = useState([
    {
      id: 1,
      name: 'Property address',
      text: 'Hi, \n\nCan you let me know you address and best way to get to hotel from the airport? \n\nThanks, \nJo Blogs',
    },
    {
      id: 2,
      name: 'Complaint',
      text: 'Hi, \n\nI just stayed at your hotel and it was the worst experience of my life. When I checked in the room was dirty, the bed was not made and there were no towels.\nI will never stay there again! \n\nRegards, \nJo Blogs',
    },
    {
      id: 3,
      name: 'Room availability & rates inquiry',
      text: 'Hello there, \n\nCan you tell me rates for a standard room from the next Sunday to Wednesday in a standard room for one adult please. \n\nCheers, \nFred',
    },
    {
      id: 4,
      name: 'Cancel reservation',
      text: 'Hi, \n\nI need to cancel my booking for tomorrow and I booked with booking.com, is there a cancellation fee.My confirmation number is #22552627 and it under the Name Peter Holland. \n\n Thanks!',
    },
    {
      id: 5,
      name: 'Shuttle service',
      text: 'Hi, \n\nDoes you hotel have a shuttle service from the airport to the hotel? \n\nThanks, \nJo',
    },
  ]);

  // Selected template tracking
  const [selectedTemplate, setSelectedTemplate] = useState('');

  const handleTextChange = (e) => setEmailText(e.target.value);

  //  Handle dropdown selection
  const handleTemplateSelect = (e) => {
    const selectedId = e.target.value;
    setSelectedTemplate(selectedId);

    const selected = templates.find((t) => t.id === parseInt(selectedId));
    if (selected) {
      setEmailText(selected.text);
    }
  };

  useEffect(() => {
    if (pid !== undefined && dynamicFlowList.length > 0) {
      let obj = dynamicFlowList.filter((d) => d.propertyId === pid);
      let url = `${process.env.REACT_APP_CHAT_API}/question-sets`;
      AxiosPublicAPI({
        method: 'get',
        url: `${url}?id=${obj[0]?.dynamicConversationFlowId}`,
      }).then((res) => {
        if (res.data?.result) {
          setQuestionSet(res.data.result);
        }
      });
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Internal_Property_By_Id}/${
          propertyDetails?.id
        }?group_id=${getGroupID()}`,
      }).then((res) => {
        setProperty(res.data);
      });
    }
  }, [pid]);

  const handleSend = () => {
    setIsLoading(true);
    let queryUrl = `${postAPI_GPT_Query}/query-chatbot-json-system`;
    let systemTools = [];
    let toolsInstructions = '';
    if (
      questionSet?.flowInvokeApi
      // questionSet.flowInvokeApi?.isEnabled == true
    ) {
      let tools = questionSet.flowInvokeApi?.items;
      tools.map((obj) => {
        systemTools.push({
          type: 'function',
          function: JSON.parse(obj.json),
        });
        toolsInstructions += obj?.instructions;
      });
    }

    if (questionSet?.openAiModel === 'AzureGpt4') {
      queryUrl = `${postAPI_GPT_Query}/query-azure-json-system`;
    }
    AxiosAPI({
      method: 'post',
      url: `${queryUrl}`,
      data: {
        groupId: getGroupID(),
        propertyId: propertyId,
        language: lang,
        q: emailText,
        suffix: 'Response always need to come at ' + lang + ' language',
        conversationId: propertyId,
        propertyName: property?.name,
        modelName:
          questionSet?.openAiModel === 'AzureGpt4'
            ? 'gpt-4o-mini'
            : questionSet?.openAiModel,
        verbosity: questionSet?.openAiVerbosity,
        indexVersion: property?.searchIndexVersion,
        index: property?.searchIndexName,
        history: [{ human: '' }],
        systemInstructions:
          moment().format('LLLL') + ' ' + questionSet?.instructions ??
          ' ' + toolsInstructions ??
          ' ' + 'Response always need to come at ' + lang + ' language',
        tools: systemTools,
      },
    })
      .then(async (result) => {
        if (result.data.arguments !== undefined) {
          let data = JSON.parse(result.data.arguments);
          let obj = '';
          if (result.data?.name === 'rates_availability') {
            let checkInDate = data?.checkInDate;
            let checkOutDate = data?.checkOutDate;
            let group = data?.group;
            let location = data?.location;
            let responseFormat = data?.responseFormat;
            let promoCode = data?.promoCode || '';
            let bestRate = data?.bestRate || '';
            await Axios(
              `${process.env.REACT_APP_CHAT_API}/find-by-property?propertyId=${pid}&groupId=${getGroupID()}`,
              {
                method: 'get',
              }
            ).then(async (response) => {
              console.log(93, response);
              if (
                moment(data?.checkInDate).format('YYYY') <
                moment().format('YYYY')
              )
                checkInDate =
                  moment().format('YYYY') +
                  '-' +
                  moment(data?.checkInDate).format('MM-DD');

              if (
                moment(data?.checkOutDate).format('YYYY') <
                moment().format('YYYY')
              )
                checkOutDate =
                  moment().format('YYYY') +
                  '-' +
                  moment(data?.checkOutDate).format('MM-DD');

              let availabilityurl = `${
                process.env.REACT_APP_PARTNER_URL
              }/public/availability/${response.data.Id}?children=${
                data?.numberOfChildren
              }&ratePlanCode=&channel=${
                response.data.Channel
              }&rooms=1&bestRate=${bestRate}&promoCode=${promoCode}&group_id=${getGroupID()}&adults=${
                data?.numberOfAdults
              }&dateIn=${checkInDate}&dateOut=${checkOutDate}&discount=${0}`;
              console.log(availabilityurl, 'availabilityurl');
              await Axios({
                url: availabilityurl,
                method: 'get',
              })
                .then(async (res) => {
                  const roomTypes = res.data.roomTypes;
                  console.log(93, res.data.roomTypes);
                  await Axios(
                    `${
                      process.env.REACT_APP_CHAT_API
                    }/searchbookingengineurl?propertyId=${pid}&groupId=${getGroupID()}`,
                    {
                      method: 'get',
                    }
                  ).then(async (engineRes) => {
                    console.debug(engineRes);
                    const dateFormat = engineRes.data.result.dateFormat;
                    let bookingUrl = engineRes.data.result.bookingUrl;

                    bookingUrl = bookingUrl.replace(
                      '{CHECK_IN}',
                      moment(checkInDate).format(dateFormat)
                    );
                    bookingUrl = bookingUrl.replace(
                      '{CHECK_OUT}',
                      moment(checkOutDate).format(dateFormat)
                    );
                    bookingUrl = bookingUrl.replace(
                      '{ADULTS}',
                      data?.numberOfAdults
                    );
                    bookingUrl = bookingUrl.replace(
                      '{CHILDREN}',
                      data?.numberOfChildren
                    );
                    bookingUrl = bookingUrl.replace('{promoCode}', promoCode);
                    bookingUrl = bookingUrl.replace('{categoryGroup}', group);
                    bookingUrl = bookingUrl.replace('{location}', location);
                    bookingUrl = bookingUrl.replace('{LANGUAGE}', 'en');

                    console.log(engineRes.data.result.bookingUrl, bookingUrl);

                    if (roomTypes !== undefined && roomTypes.length > 0) {
                      let isAvailable = false;
                      for (let i = 0; i < roomTypes.length; i++) {
                        if (roomTypes[i].available === true) {
                          isAvailable = true;
                          break;
                        }
                      }
                      if (isAvailable) {
                        AxiosAPI({
                          method: 'post',
                          url: `${queryUrl}`,
                          data: {
                            groupId: getGroupID(),
                            propertyId: pid,
                            language: lang,
                            q: '',
                            suffix:
                              'Response always need to come at ' +
                              lang +
                              ' language',
                            conversationId: 'cid',
                            propertyName: property?.name,
                            modelName: 'gpt-4o-mini',
                            modelName:
                              questionSet?.openAiModel === 'AzureGpt4'
                                ? 'gpt-4o-mini'
                                : questionSet?.openAiModel,
                            verbosity: questionSet?.openAiVerbosity,
                            indexVersion: property?.searchIndexVersion,
                            index: property?.searchIndexName,
                            history: [
                              { human: reply, ai: JSON.stringify(roomTypes) },
                              {
                                human: '',
                                ai: `<a href='${bookingUrl}' target='_blank'>Book Your Room</a>`,
                              },
                            ],
                            systemInstructions:
                              moment().format('LLLL') +
                              ' ' +
                              (questionSet?.instructions ?? '') +
                              'Response always need to come at ' +
                              lang +
                              ' language',
                            tools: systemTools,
                          },
                        }).then(async (bookingRes) => {
                          if (bookingRes.data.arguments !== undefined) {
                            let bookingResData = JSON.parse(
                              bookingRes.data.arguments
                            );
                            console.log(bookingResData);
                            if (bookingResData?.response) {
                              obj = bookingResData?.response.replace(
                                /\n/g,
                                '<br />'
                              );
                              setReply(obj);
                              setIsLoading(false);
                            } else {
                              setReply(
                                '<p>' + bookingResData?.response + '</p>'
                              );
                              setIsLoading(false);
                            }
                          }
                        });
                      }
                    } else {
                      setReply(
                        "Sorry... I'm not able to process the request right now. Can I help you with anything else?"
                      );
                      setIsLoading(false);
                    }
                  });
                })
                .catch((error) => {
                  console.log(error);
                  setReply(
                    "Sorry... I'm not able to process the request right now. Can I help you with anything else?"
                  );
                  setIsLoading(false);
                });

              const diff = moment(
                moment(checkOutDate).format('YYYY-MM-DD')
              ).diff(moment(checkInDate).format('YYYY-MM-DD'), 'days');
              await Axios(
                `${process.env.REACT_APP_CHAT_API}/booking-engine-data`,
                {
                  method: 'post',
                  data: {
                    groupId: getGroupID(),
                    propertyId: pid,
                    checkInDate: moment(checkInDate).format('YYYY-MM-DD'),
                    checkOutDate: moment(checkOutDate).format('YYYY-MM-DD'),
                    nights: diff,
                    adults: data?.numberOfAdults,
                    childrens: data?.numberOfChildren,
                    creator: 'webview',
                    promoCode: '',
                  },
                }
              ).catch((error) => {
                console.log(error);
                setReply(
                  "Sorry... I'm not able to process the request right now. Can I help you with anything else?"
                );
                setIsLoading(false);
              });
            });
          } else {
            console.log(data?.response);
            if (data?.response) {
              obj = data?.response.replace(/\n/g, '<br />');
              setReply('<p>' + obj + '</p>');
              setIsLoading(false);
            }
          }
        }
      })
      .catch((err) => console.log(err));
  };
  const handleChange = (e) => {
    setPid(e.target.value);
  };

  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody name="bodyClick text-center">
          <div className="col-md-12 text-center">
            <h4>Preview Email</h4>
          </div>
          <Separator className="mb-2" />
          <Row>
            <Colxx xxs="12" className="mb-3">
              <Label>Property</Label>
              <Input
                type="select"
                value={pid}
                name="pid"
                style={{ width: '100%' }}
                onChange={(e) => handleChange(e)}
              >
                <option value="">Please Select</option>
                {propertyList &&
                  propertyList
                    .filter(
                      (f) =>
                        dynamicFlowList.filter(
                          (d) =>
                            d.propertyId === f.id &&
                            d.dynamicConversationFlowId !== ''
                        ).length > 0
                    )
                    .map((p) => <option value={p.id}>{p.name}</option>)}
              </Input>
            </Colxx>
            <Colxx xxs="12" className="mb-3">
              <span>
                <b>Type your email or select one of the available examples</b>
              </span>
            </Colxx>

            {/* Template Dropdown */}
            <Colxx xxs="12" className="mt-3">
              <FormGroup>
                <Label for="templateSelect">
                  <b>Select Template</b>
                </Label>
                <Input
                  type="select"
                  id="templateSelect"
                  value={selectedTemplate}
                  onChange={handleTemplateSelect}
                >
                  <option value="">-- Choose a template --</option>
                  {templates.map((template) => (
                    <option key={template.id} value={template.id}>
                      {template.name}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Colxx>

            <Colxx xxs="12" className="mt-3">
              <Input
                type="textarea"
                value={emailText}
                name="text"
                placeholder="Email"
                onChange={(e) => handleTextChange(e)}
                style={{ height: '200px' }}
              />
            </Colxx>
          </Row>
          <div className="d-flex justify-content-center mb-2">
            <ButtonGroup
              className="mb-2 text-center"
              style={{ marginTop: '40px' }}
            >
              <Button color="primary" size="xs" outline onClick={handleSend}>
                Send
              </Button>
            </ButtonGroup>
          </div>
          {isLoading ? (
            <div className="text-center">
              <div className="loading" />
            </div>
          ) : (
            <Fragment>
              {reply !== '' && (
                <Row className="mb-3">
                  <Colxx xxs="12" className="mt-3">
                    <span>
                      <b>Reply</b>
                    </span>
                  </Colxx>
                  <Colxx xxs="12" className="mt-3">
                    {parse(reply)}
                  </Colxx>
                </Row>
              )}
            </Fragment>
          )}
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default PreviewReply;
